const yearToDateDropdown = () => {
  const year = new Date().getFullYear();
  let dropdown = [];

  for (let i = year; i >= 2010; i--) {
    dropdown.push({ value: i, label: i });
  }

  return dropdown;
};

export default yearToDateDropdown;
